import { render, staticRenderFns } from "./OrganismNotFound.vue?vue&type=template&id=3e95a4ba"
import script from "./OrganismNotFound.vue?vue&type=script&lang=js"
export * from "./OrganismNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports